export class PlayerProgress {
  constructor(player) {
    this._player = player;
  }

  get isInfinityUnlocked() {
    return new Decimal(this._player.infinities).gt(0) || this.isEternityUnlocked;
  }

  get isEternityUnlocked() {
    return new Decimal(this._player.eternities).gt(0) || this.isRealityUnlocked;
  }
  
  get isEternityUnlocked() {
    return new Decimal(this._player.eternities).gt(0) || this.isRealityUnlocked;
  }

  get isRealityUnlocked() {
    return new Decimal(this._player.realities).gt(0);
  }

  get hasFullCompletion() {
    return this._player.records?.fullGameCompletions > 0;
  }

  static get current() {
    return new PlayerProgress(player);
  }

  static of(player) {
    return new PlayerProgress(player);
  }

  static infinityUnlocked() {
    return PlayerProgress.current.isInfinityUnlocked;
  }

  static hasBroken() {
    return player.break || this.eternityUnlocked();
  }

  static replicantiUnlocked() {
    return Replicanti.areUnlocked || this.eternityUnlocked();
  }

  static eternityUnlocked() {
    return PlayerProgress.current.isEternityUnlocked;
  }

  static dilationUnlocked() {
    return TimeStudy.dilation.isBought;
  }

  static realityUnlocked() {
    return PlayerProgress.current.isRealityUnlocked;
  }

  static seenAlteredSpeed() {
    const ec12 = EternityChallenge(12);
    return this.realityUnlocked() || ec12.completions > 0 || ec12.isRunning;
  }

  static challengeCompleted() {
    return NormalChallenges.all.slice(1).some(c => c.isCompleted);
  }

  static infinityChallengeCompleted() {
    return InfinityChallenges.all.some(c => c.isCompleted);
  }

  //added
  static dimensionBoostUnlocked() {
    return player.dimensionBoosts.gt(0) || this.galaxyUnlocked()
  }

  static galaxyUnlocked() {
    return player.galaxies.gt(0) || this.infinityUnlocked()
  }

  static IDUnlocked(id) {
    return this.eternityUnlocked() ||
          InfinityDimension(id).isUnlocked
  }

  static reachedEternities(count) {
    return PlayerProgress.current.isRealityUnlocked || player.eternities.gte(count);
  }
}
